import { render } from "./DbsTermsLinkButton.vue?vue&type=template&id=e884b41e"
import script from "./DbsTermsLinkButton.vue?vue&type=script&lang=js"
export * from "./DbsTermsLinkButton.vue?vue&type=script&lang=js"
script.render = render

export default script